import { gql } from 'graphql-request';

import {
  LifestyleSetDownloadUrlsClassName,
  LifestyleSetDownloadUrlsID,
  LifestyleSetDownloadUrlsType,
  LifestyleSetDownloadUrlsUrl,
  LifestyleSetDownloadUrlsUUID,
  LifestylesSetID,
  LifestylesSetUUID
} from '../lifestylesSetsTypes';

export interface FetchLifestylesSetDownloadUrlsQueryResponse {
  id: LifestylesSetID;
  uuid: LifestylesSetUUID;
  downloadUrls: {
    url: LifestyleSetDownloadUrlsUrl;
    id: LifestyleSetDownloadUrlsID;
    uuid: LifestyleSetDownloadUrlsUUID;
    type: LifestyleSetDownloadUrlsType;
    className: LifestyleSetDownloadUrlsClassName;
  }[];
}

export const FETCH_LIFESTYLES_SET_DOWNLOAD_URLS_QUERY = gql`
  query LifestylesSetDownloadUrls($uuid: ID!) {
    lifestylesSet(uuid: $uuid) {
      id
      uuid
      downloadUrls {
        className
        url
        id
        uuid
        type
      }
    }
  }
`;
